var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xzgdFooter"},[_c('div',{staticStyle:{"padding":"20px 0"}},[_c('p',{staticClass:"tips"},[_vm._v("徐州广播电视传媒集团（徐州广播电视台） 版权所有")]),_c('p',{staticClass:"tips"},[_vm._v("苏ICP备10017019号-1")])])])
}]

export { render, staticRenderFns }